import React from 'react';

export const CheckIcon = ({ width = 24, height = 25, color = "white", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 25"
            fill="none"
        >
            <path
                className={className}
                d="M9.55 15.7999L18.025 7.3249C18.225 7.1249 18.4583 7.0249 18.725 7.0249C18.9917 7.0249 19.225 7.1249 19.425 7.3249C19.625 7.5249 19.725 7.76257 19.725 8.0379C19.725 8.31324 19.625 8.55057 19.425 8.7499L10.25 17.9499C10.05 18.1499 9.81666 18.2499 9.55 18.2499C9.28333 18.2499 9.05 18.1499 8.85 17.9499L4.55 13.6499C4.35 13.4499 4.254 13.2126 4.262 12.9379C4.27 12.6632 4.37433 12.4256 4.575 12.2249C4.77566 12.0242 5.01333 11.9242 5.288 11.9249C5.56266 11.9256 5.8 12.0256 6 12.2249L9.55 15.7999Z"
                fill={color}
            />
        </svg>
    );
};